'use strict';

module.exports = function (_ref) {
  var libp2p = _ref.libp2p;
  return {
    subscribe: function subscribe() {
      var _libp2p$pubsub;

      return (_libp2p$pubsub = libp2p.pubsub).subscribe.apply(_libp2p$pubsub, arguments);
    },
    unsubscribe: function unsubscribe() {
      var _libp2p$pubsub2;

      return (_libp2p$pubsub2 = libp2p.pubsub).unsubscribe.apply(_libp2p$pubsub2, arguments);
    },
    publish: function publish() {
      var _libp2p$pubsub3;

      return (_libp2p$pubsub3 = libp2p.pubsub).publish.apply(_libp2p$pubsub3, arguments);
    },
    ls: function ls() {
      var _libp2p$pubsub4;

      return (_libp2p$pubsub4 = libp2p.pubsub).getTopics.apply(_libp2p$pubsub4, arguments);
    },
    peers: function peers() {
      var _libp2p$pubsub5;

      return (_libp2p$pubsub5 = libp2p.pubsub).getSubscribers.apply(_libp2p$pubsub5, arguments);
    }
  };
};